export default {
  app: {
    place: {
      address: 'Cím',
      showOnExternalMaps: 'Megjelenítés a Google Térképen',
    },
  },
};
